// Shared invoice utility functions — single source of truth.
// Used by InvoiceScanner, InvoiceReviewPage, and other confirm paths.

// Clean invoice number for storage: trim, fix leading 0→O
export function cleanInvNumber(raw) {
  const t = (raw || '').trim();
  return t.replace(/^0(?=\d)/, 'O');
}

// Normalize invoice number for duplicate comparison: strip spaces, dashes, case, leading #, treat 0/O as same
export function normalizeInvNumber(raw) {
  if (!raw) return '';
  return raw.trim().replace(/[\s-]/g, '').replace(/^#/, '').toUpperCase().replace(/^0(?=\d)/, 'O');
}

// Normalize vendor name: trim, title case, handle hyphens
export function normalizeVendor(raw) {
  if (!raw) return '';
  return raw.trim().toLowerCase().split(/(\s+|-)/).map(part => {
    if (part === '-' || !part.trim()) return part;
    return part.charAt(0).toUpperCase() + part.slice(1);
  }).join('');
}

// Strip vendor suffixes and punctuation for fuzzy comparison
const VENDOR_SUFFIXES = /\b(inc|llc|ltd|co|corp|company|enterprises|beverages|northeast|southeast|northwest|southwest|north|south|east|west|of|the)\b/gi;

export function vendorKey(raw) {
  return (raw || '').toLowerCase().replace(/[^a-z0-9\s]/g, '').replace(VENDOR_SUFFIXES, '').replace(/\s+/g, ' ').trim();
}

export function vendorsFuzzyMatch(a, b) {
  const ka = vendorKey(a), kb = vendorKey(b);
  if (!ka || !kb) return false;
  return ka === kb || ka.includes(kb) || kb.includes(ka);
}
